import { ConcurrentEntryGuard } from "services/utils";
import { fetchGraphql, baseUrl, getRefreshToken, setTokens, type GraphQlResult } from ".";
import { LoginMutation, LoginMutationVariables, LogoutAllDevicesMutation, LogoutAllDevicesMutationVariables } from "../../graphql/types";
import { loginMutation, logoutAllDevicesMutation } from "../../graphql/queries";

type Tokens = { access_token: string, refresh_token?: string };

const refreshTokenGuard = new ConcurrentEntryGuard<boolean>();

export function tryRefreshToken() {
    return refreshTokenGuard.call(async () => {
        const refreshToken = getRefreshToken();
        if (refreshToken) {
            const tokens = await fetchRefreshTokenRequest(refreshToken);
            if (tokens) {
                setTokens(tokens.access_token, tokens.refresh_token);
                return true;
            }
        }
        return false;
    });
}

export async function fetchRefreshTokenRequest(refreshToken: string): Promise<Tokens | null> {
    if (refreshToken) {
        const response = await fetch(baseUrl + "/api/token", {
            method: "POST",
            mode: "cors",
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
            },
            body: JSON.stringify({
                grant_type: "refresh_token",
                refresh_token: refreshToken,
            }),
        });
        if (response.ok) {
            const json = await response.json() as Tokens;
            if (json?.access_token) {
                return json
            }
        }
    }
    return null;
}

export async function fetchLoginRequest(email: string, password: string): Promise<GraphQlResult<LoginMutation>> {
    return await fetchGraphql<LoginMutation, LoginMutationVariables>("Login", loginMutation, { email, password }, false);
}

export async function fetchLogoutAllDevices() {
    return await fetchGraphql<LogoutAllDevicesMutation, LogoutAllDevicesMutationVariables>("LogoutAllDevices", logoutAllDevicesMutation, {}, true);
}
